import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-check-in-out-report',
    templateUrl: './check-in-out-report.component.html',
    styleUrls: ['./check-in-out-report.component.css'],
    standalone: false
})
export class CheckInOutReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
